import React, { Component } from "react";

import { Container, Icon, Row, Col } from "design-react-kit";
import { BoxDanger, BoxInfo, BoxSuccess, MnemoLoading, SupportoTecnico, Title } from "components/misc";
import { courseService, networkErrorHelper } from "libs";
import { withRouter } from "react-router-dom";
import jsPDF from "jspdf";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTES } from "const";

class MyBadge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rCode: 0,
      qrCodeData: {},
      loading: true,
      loadingError: false,
    };
  }

  componentDidMount() {
    // get registration code from parameter
    const { rCode } = this.props.match.params;
    this.setState({ rCode: rCode });
    this.loadRemote(rCode);
  }


  async loadRemote(rCode) {

    this.setState({ loading: true, loadingError: false });
    courseService
      .getQrCodeByRCode(rCode)
      .then(({ data }) => {
        this.setState({
          qrCodeData: data.payload.qrCode,
          loading: false,
          loadingError: false,
        });
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
        this.setState({ loading: false, loadingError: true });
      });
  }

  generatePDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    let yPosition = 30;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(24);
    const text = "Badge Accesso Aula";
    const textWidth = doc.getTextWidth(text);
    const x = (pageWidth - textWidth) / 2;
    doc.text(text, x, 24);

    const { qrCodeData } = this.state;
    if (qrCodeData.imageData) {
      const imageWidth = 100;
      const imageHeight = 100;
      const x = (pageWidth - imageWidth) / 2;

      doc.addImage(
        qrCodeData.imageData,
        "PNG",
        x,
        yPosition,
        imageWidth,
        imageHeight
      );
      yPosition += imageHeight + 10; // Aggiungi un margine di 10
    } else {
      doc.text("QR Code non disponibile", 10, 90);
    }

    //--- name surname ---
    doc.setFont("helvetica", "normal", "bold");
    doc.setFontSize(16);
    const text1 = "Nome e Cognome: " + qrCodeData.nameSurname;
    const xPosition = 20;
    yPosition += 12;
    doc.text(text1, xPosition, yPosition);

    const text2 = "Identificativo: " + qrCodeData.registrationCode;
    yPosition += 12;
    doc.text(text2, xPosition, yPosition);

    //--- corso ---
    const text3 = "Percorso: " + qrCodeData.courseName;
    const maxWidth = 150;
    const wrappedText = doc.splitTextToSize(text3, maxWidth);

    let currentYPosition = yPosition + 15;
    wrappedText.forEach((line) => {
      doc.text(line, xPosition, currentYPosition);
      currentYPosition += 8;
    });   

    doc.save("badge_accesso_aula_" + this.state.rCode + ".pdf");
  };


  //--- ---

  render() {
    const { qrCodeData, loading, loadingError, rCode } = this.state;

    return (
      <>
        <section className="my-4">
          <Container>
            <NavLink
              to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
              className="mx-5 btn btn-outline-primary float-right">
              <Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO
            </NavLink>
            <Title>Badge accesso aula</Title>
            <div className="col-md-12">
              <BoxSuccess>
                L'utilizzo del Badge a Lei assegnato, è strettamente personale e costituisce requisito indispensabile per la partecipazione alle 
                attività in presenza. Esso dovrà essere obbligatoriamente esibito e autenticato sia all'ingresso sia all'uscita dell'aula, in formato cartaceo o digitale, 
                previa presentazione di un valido documento di riconoscimento.<br />
                <b>ATTENZIONE:</b>l'accesso o l'uscita dall'aula senza la corretta procedura di autenticazione del Badge, effettuata esclusivamente dal personale di
                 segreteria presente in sede, comporterà la mancata registrazione della presenza per l'attività di riferimento ovvero l'assenza.
              </BoxSuccess>
            </div>
            {loading ? (<MnemoLoading></MnemoLoading>) :
              (loadingError ? (<BoxDanger>Si è verificato un problema durante il caricamento della pagina, se il <SupportoTecnico />.</BoxDanger>) :
                (<Row>
                  <Col md={4} className="text-center">
                    <div>
                      <img
                        src={qrCodeData.imageData}
                        width="90%"
                        height="auto"
                        title="Badge accesso aula"
                        alt="Badge accesso aula"
                      />
                      <div>
                        <button
                          className="btn btn-primary bg-dark"
                          onClick={this.generatePDF}
                        >
                          Scarica in formato PDF
                        </button>
                      </div>
                    </div>

                  </Col>
                  <Col md={8}>
                    <BoxInfo className="mt-4">
                      <h5><b>Identificativo</b>: {rCode}</h5>
                      <h5><b>Nome e Cognome</b>: {qrCodeData.nameSurname}</h5>
                      <h5><b>Percorso</b>: {qrCodeData.courseName}</h5>                     
                    </BoxInfo>
                  </Col>
                </Row>
                ))}
          </Container>
        </section>
      </>
    );
  }
}

export default withRouter(MyBadge);
